import { Typography } from '@mui/material';
import React from 'react';
import ClientList from '../../components/Contractors/Clients/ClientList';

const ContractorClients = () => {
    return (
        <div>
            <Typography variant='h1'>Clients</Typography>
            <ClientList />
        </div>
    );
};

export default ContractorClients;
